import styled from '@emotion/styled';

export const SuccessBannerBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    min-width: 0;
    padding: 12px 14px;
`;

export const SuccessBannerTitle = styled.div`
    font-weight: 700;
    font-size: 14px;
    color: #166534;
    overflow-wrap: anywhere;
`;

export const SuccessBannerDescription = styled.div<{ $markdown?: boolean }>`
    color: #111827;
    font-size: 13px;
    line-height: 20px;
    white-space: ${(props) => (props.$markdown ? 'normal' : 'pre-line')};
    overflow-wrap: anywhere;

    ${(props) => (props.$markdown ? 'p { margin: 0; }' : '')}
`;

export const SuccessBannerActions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
`;
